<!--ANA、ENA抗体谱、ANCA、自身免疫性肝病抗体谱-->
<script setup>
import { computed, reactive,watch,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
import upload from "@/components/upload1.vue"
import check from "./check.vue";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

let arrs = [
">","<","=","≥","≤"
]
// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});
 
// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});
// console.log(props.type,'000000');
//字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
// 选择未测
const weice = reactive({
  input1:false,
  input2:false,
  input3:false,
})
// model.fields[`${props.type}`]||=['类风湿因子_是否未测']
watch(()=>model.fields[`${props.type}`]?.['类风湿因子_是否未测'],(newval,oldval)=>{
  if (newval?.length) {
  console.log(newval,'未测')
  model.fields[`${props.type}`]['类风湿因子'] = ''
  weice.input1 = true
  }else{
  weice.input1 = false

  }
})
// model.fields[`${props.type}`]||=['其他自身抗体（如抗DNA抗体等）_是否未测']
watch(()=>model.fields[`${props.type}`]?.['其他自身抗体（如抗DNA抗体等）_是否未测'],(newval,oldval)=>{
  if (newval?.length) {
  console.log(newval,'未测')
  model.fields[`${props.type}`]['其他自身抗体（如抗DNA抗体等）'] = ''
  weice.input2 = true
  }else{
  weice.input2 = false

  }
})

// try {
// model.fields[`${props.type}`]||=['铜蓝蛋白（g/L）_是否未测']
// watch(()=>model.fields[`${props.type}`]['铜蓝蛋白（g/L）_是否未测'],(newval,oldval)=>{
//   if (newval?.length) {
//   console.log(newval,'未测')
//   model.fields[`${props.type}`]['铜蓝蛋白（g/L）'] = ''
//   weice.input3 = true
//   }else{
//   weice.input3 = false

//   }
// })
// }catch (error) {
// }
try {
    // 使用可选链操作符避免读取未定义属性
    const isNotMeasured = model.fields[`${props.type}`]?.['铜蓝蛋白（g/L）是否未测'];
    
    watch(() => model.fields[`${props.type}`]?.['铜蓝蛋白（g/L）_是否未测'], (newval, oldval) => {
        if (newval?.length) {
            console.log(newval, '未测');
            model.fields[`${props.type}`]['铜蓝蛋白（g/L）'] = '';
            weice.input3 = true;
        } else {
            weice.input3 = false;
        }
    });
} catch (error) {
    console.error('处理铜蓝蛋白数据时出错:', error);
}


;
</script>
<template>
  <template v-if="crfFields">
    <div style="display: flex;">

      <h2>自身抗体谱</h2>
      <upload :type="props.type" :data="model" name="anaanca"></upload>
      <check :period="props.type" text="自身抗体谱" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="自身抗体谱检查是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['自身抗体谱检查是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['自身抗体谱检查是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen? '患者是否新增自身抗体谱检查？':'患者是否进行自身抗体谱检查？'" class="redStar">
          <el-radio-group v-model="crfFields['患者是否进行自身抗体谱检查？']">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
            <el-radio label="未测" prop="未测"></el-radio>
            <!-- <el-radio label="不清楚"></el-radio> -->
          </el-radio-group>
        </el-form-item>
        <template class="content" v-if="crfFields['患者是否进行自身抗体谱检查？'] == '是'">
          
          
          <el-form-item label="类风湿因子（IU/ml）" class="redStar" :prop="itemProp(`类风湿因子`)" :rules="crfFields['类风湿因子_是否未测']?.length > 0 || crfStore.textRules(`类风湿因子`,true)">
            <div class="leiyinzi">
              <el-select v-model="crfFields['类风湿因子符号']" class="m-2" placeholder="请选择" :disabled="weice.input1">
                <el-option
                  v-for="item in arrs"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
              <el-input v-model="crfFields['类风湿因子']" autocomplete="off" :disabled="weice.input1">
                <template #append>IU/ml</template>
              </el-input>
              <el-checkbox-group v-model="crfFields['类风湿因子_是否未测']" style="margin-left: 10px;">
                  <el-checkbox label="未测"></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
      
          <el-form-item label="抗肝肾微粒体抗体" class="redStar" :prop="itemProp(`抗肝肾微粒体抗体`)" :rules="crfStore.radioRules(`抗肝肾微粒体抗体`)">
            <el-radio-group v-model="crfFields['抗肝肾微粒体抗体']">
              <el-radio label="阳性"></el-radio>
              <el-radio label="阴性"></el-radio>
              <el-radio label="未测"></el-radio>
            </el-radio-group>
          </el-form-item>
        
          <el-form-item label="抗核抗体" class="redStar" :prop="itemProp(`抗核抗体`)" :rules="crfStore.radioRules(`抗核抗体`)">
            <el-radio-group v-model="crfFields['抗核抗体']"> 
              <el-radio label="阳性" prop="阳性"></el-radio>
              <el-radio label="阴性" prop="阴性"></el-radio>
              <el-radio label="未测"></el-radio>
            </el-radio-group>
            <el-input v-if="crfFields['抗核抗体']?.includes('阳性')" v-model="crfFields['抗核抗体阳性txt']" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="抗平滑肌抗体" class="redStar" :prop="itemProp(`抗平滑肌抗体`)" :rules="crfStore.radioRules(`抗平滑肌抗体`)">
            <el-radio-group v-model="crfFields['抗平滑肌抗体']">
              <el-radio label="阳性" prop="阳性"></el-radio>
              <el-radio label="阴性" prop="阴性"></el-radio>
              <el-radio label="未测"></el-radio>

            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="抗肝细胞溶质抗原1型" class="redStar" :prop="itemProp(`抗肝细胞溶质抗原1型`)" :rules="crfStore.radioRules(`抗肝细胞溶质抗原1型`)">
            <el-radio-group v-model="crfFields['抗肝细胞溶质抗原1型']">
              <el-radio label="阳性" prop="阳性"></el-radio>
              <el-radio label="阴性" prop="阴性"></el-radio>
              <el-radio label="未测"></el-radio>

            </el-radio-group>
          </el-form-item>
          <el-form-item label="pANCA" class="redStar" :prop="itemProp(`pANCA`)" :rules="crfStore.radioRules(`pANCA`)">
            <el-radio-group v-model="crfFields['pANCA']">
              <el-radio label="阳性" prop="阳性"></el-radio>
              <el-radio label="阴性" prop="阴性"></el-radio>
              <el-radio label="未测"></el-radio>

            </el-radio-group>
          </el-form-item>

          <el-form-item label="cANCA" class="redStar" :prop="itemProp(`cANCA`)" :rules="crfStore.radioRules(`cANCA`)">
            <el-radio-group v-model="crfFields['cANCA']">
              <el-radio label="阳性" prop="阳性"></el-radio>
              <el-radio label="阴性" prop="阴性"></el-radio>
              <el-radio label="未测"></el-radio>

            </el-radio-group>
          </el-form-item>

          <el-form-item label="SS-A" class="redStar" :prop="itemProp(`SS-A`)" :rules="crfStore.radioRules(`SS-A`)">
            
            <el-radio-group v-model="crfFields['SS-A']">
              <el-radio label="阳性" prop="阳性"></el-radio>
              <el-radio label="阴性" prop="阴性"></el-radio>
              <el-radio label="未测"></el-radio>

            </el-radio-group>
            
          </el-form-item>

          <el-form-item label="SS-B" class="redStar" :prop="itemProp(`SS-B`)" :rules="crfStore.radioRules(`SS-B`)">
            <el-radio-group v-model="crfFields['SS-B']">
              <el-radio label="阳性" prop="阳性"></el-radio>
              <el-radio label="阴性" prop="阴性"></el-radio>
              <el-radio label="未测"></el-radio>

            </el-radio-group>
          </el-form-item>

          <el-form-item label="其他自身抗体（如抗DNA抗体等）" class="redStar" :prop="itemProp(`其他自身抗体（如抗DNA抗体等）`)" :rules="crfFields['其他自身抗体（如抗DNA抗体等）_是否未测']?.length > 0 ||crfStore.textRules(`其他自身抗体（如抗DNA抗体等）`,true)">
            <div style="display: flex;">
            <el-input v-model="crfFields['其他自身抗体（如抗DNA抗体等）']" autocomplete="off" :disabled="weice.input2">
              <!-- <template #append>IU/ml</template> -->
            </el-input>
            <el-checkbox-group v-model="crfFields['其他自身抗体（如抗DNA抗体等）_是否未测']" style="margin-left: 10px;">
                  <el-checkbox label="未测"></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>

          <el-form-item v-if="props.type != 'V0肝穿点±2周'" label="铜蓝蛋白（g/L）" class="redStar" :prop="itemProp(`铜蓝蛋白（g/L）`)" :rules="crfStore.textRules(`铜蓝蛋白（g/L）`,true)">
            <div style="display: flex;">
              <el-input v-model="crfFields['铜蓝蛋白（g/L）']" autocomplete="off" :disabled="weice.input3">
                <template #append>g/L</template>
              </el-input>
              <el-checkbox-group v-model="crfFields['铜蓝蛋白（g/L）_是否未测']" style="margin-left: 10px;">
                  <el-checkbox label="未测"></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
        </template>
      </template>
    </template>
</template>

<style lang="scss" scoped>
.content{
  padding-left: 20px;
}
.leiyinzi{
  display: flex;
  .m-2{
    width: 100px;
  }
}
</style>